import { useSyncExternalStore } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { BTN_PRIMARY_SM, BTN_SECONDARY_SM } from './buttonStyles';
import { dismissProposalBanner, proposalBanner, subscribeProposalBanner } from '../services/proposalBanner';

/**
 * A time proposal's in-app banner (decision 160): when its push arrives with the app open, "New times
 * suggested" and the push's line at the top, with Pick a Time (the lesson page, where the times are) and Not
 * Now. Text capsules at every width. Not on the lesson's own page, whose main card already carries the times.
 */
export function ProposalBanner() {
  const item = useSyncExternalStore(subscribeProposalBanner, proposalBanner, proposalBanner);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  if (!item || (item.link && pathname === item.link)) return null;
  return (
    <div className="pointer-events-none fixed inset-x-4 top-3 z-[9998] flex justify-center" data-proposal-banner>
      <div role="alert" className="pointer-events-auto w-full max-w-[480px] rounded-[26px] bg-white px-4 py-3 shadow-[0_4px_16px_rgba(0,0,0,0.12)]">
        <p className="text-[15px] leading-[20px] font-semibold text-db-text-1">{item.title}</p>
        <p className="mt-0.5 text-[15px] leading-[20px] text-db-text-2">{item.message}</p>
        <div className="mt-3 flex gap-2">
          {item.link && (
            <button type="button" onClick={() => { dismissProposalBanner(); navigate(item.link!); }} className={BTN_PRIMARY_SM}>Pick a Time</button>
          )}
          <button type="button" onClick={dismissProposalBanner} className={BTN_SECONDARY_SM}>Not Now</button>
        </div>
      </div>
    </div>
  );
}
